import { useEffect, useState } from "react";
import { useIsVerified } from "src/components/email-verification";
import { MainCard, MainCardContent, MainCardTitle } from "src/components/main-card-type.tsx"
import {
    checkCalculatorUsageLimitAndRedirect,
    loadSavedCalculatorData,
    sanitizeBrlValue,
    saveCalculatorData,
} from "src/utils/functions";
import { Button } from "src/components/ui/button";
import { calcularINSS } from "../utils/caculadora-inssFunctions";
import { CalculoINSSResponse } from "../calcular-inss";
export const CalculadoraINSSInputCard = ({
    setResults,
}: {
    setResults: (value: CalculoINSSResponse | null) => void;
}) => {
    const [message, setMessage] = useState<string>("");
    const isVerified = useIsVerified();

    const [salariobruto, setSalariobruto] = useState("")
    const calculatorKey = "calculadora-inss";

    function handleSave() {
        saveCalculatorData(calculatorKey, {
            salariobruto,
        })
    }


    function clear() {
        setSalariobruto("");
        setMessage("");
    }

    useEffect(() => {
        const savedData = loadSavedCalculatorData(calculatorKey);
        if (!savedData) return;
        setSalariobruto((savedData.salariobruto as string) || "");
    }, []);
    function calcular() {
        if (!salariobruto || salariobruto === "0") {
            setMessage("Adicione uma valor ao Salario Bruto")
            setResults(null)
            return
        }
        setMessage("")
        const ValorBruto = Number.parseFloat(
            salariobruto.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        let ValorFinal: number = 0
        let ValorDescontado: number = 0
        let Aliquota: number = 0
        let Bruto: number = 0
        let ValorInss = calcularINSS(ValorBruto)

        ValorDescontado = ValorInss.valor
        Aliquota = ValorInss.aliquotaEfetiva
        ValorFinal = ValorBruto - ValorDescontado
        Bruto = ValorBruto
        console.log(ValorFinal, "Valor Final", Aliquota, "ALiquota", ValorDescontado);

        const resultado = {
            ValorBruto: Bruto,
            ValorFinal: ValorFinal,
            ValorDescontado: ValorDescontado,
            Aliquota: Aliquota

        }
        setResults(resultado);


    }

    return (
        <MainCard>
            <MainCardTitle>Cálculo de INSS</MainCardTitle>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSave();
                    checkCalculatorUsageLimitAndRedirect(calcular)
                }}>
                <MainCardContent>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="bruto-id">
                            Salario Bruto *
                        </label>
                        <div className="flex border">
                            <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                                R$
                            </span>
                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="bruto-id"
                                placeholder="00,00"
                                type="text"
                                value={salariobruto}
                                onChange={(event) => setSalariobruto(sanitizeBrlValue(event))}
                            />
                        </div>
                    </div>
                </MainCardContent>
                <div className="flex justify-between">
                    <Button
                        disabled={!isVerified}
                        type="submit"
                        variant={"default"}
                        className="sm:w-[150px]"
                    >
                        Calcular
                    </Button>

                    <div className="flex flex-col sm:flex-row items-center gap-2">

                        <Button onClick={clear} type="button" variant={"ghost"}>
                            Limpar
                        </Button>
                    </div>
                </div>
            </form>
            <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
        </MainCard >
    )
}
